import { useEffect, useState } from "react";
import { Button } from "primereact/button";
// import { Timeline } from "primereact/timeline";


import CardSeplag from "../../../components/CardSeplag";
import ModalSeplag from "../../../components/ModalSeplag";

import TableSeplag from "../../../components/TableSeplag";
import { buscarLogPorEmpresa } from "../../../service/Audit/Empresa";
import { pesquisarLista, buscaPersonalizada } from "../../../service/empresa";

import Timeline from '../components/Timeline'
import CustomizedContent from "./components/CustomizedContent";

import style from './style.module.css'

const ManterEmpresa = () => {
  const [ListaEmpresa, setListaEmpresa] = useState([]);
  const [visible, setVisible] = useState(false);
  const [empresaSelected, setEmpresaSelected] = useState();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    pesquisarLista().then((res) => {
      setListaEmpresa(res.content);
    });
  }, []);

  const handleSearch = (parmSearch) => {
    if (parmSearch && parmSearch !== "") {
      buscaPersonalizada(parmSearch).then((res) => {
        setListaEmpresa(res.content);
      });
    } else {
      pesquisarLista().then((res) => {
        setListaEmpresa(res.content);
      });
    }
  };

  const showModalLog = (rowData) => {

    setEmpresaSelected({ ...rowData });
    buscarLogPorEmpresa(rowData.idenEmpresa).then((res) => {
      setLogs(res.filter((element) => element.auditoriaDTO));
      setVisible(true);
    });
  };

  const camposTabela = [
    { nome: "nomeFantasia", titulo: "Nome Fantasia" },
    { nome: "cnpj", titulo: "CNPJ" },
    { nome: "descInscEstadual", titulo: "Inscrição Estadual" },
  ];

  const botoesAcoes = (rowData) => {
    return <Button
      icon="pi pi-list"
      tooltip="log"
      tooltipOptions={{ className: style.tooltipDisplay, position: "left" }}
      onClick={() => showModalLog(rowData)}
    />;
  };


  return (
    <CardSeplag title="Pessoa Jurídica">
      <TableSeplag
        dados={ListaEmpresa}
        camposTabela={camposTabela}
        searchPlaceholder="Pesquisar Pessoa Jurídica"
        onSearch={handleSearch}
        hasEventoAcao
        botoesAcoes={botoesAcoes}
      />

      {visible && (
        <ModalSeplag
          type="NONE"
          titulo={`Log da Pessoa Jurídica: ${empresaSelected.nomeFantasia} `}
          visible={visible}
          fechar={() => setVisible(false)}
          maximizable
        >

          <Timeline
            logs={logs}
            customizedContent={CustomizedContent}
          />

        </ModalSeplag>
      )}
    </CardSeplag>
  );
};
export default ManterEmpresa;
